/* Calendario dell'Avvento – sections/advent-calendar.liquid */
(function () {
  if (window.customElements.get('advent-calendar')) return;

  var LOCK_ICON = '<svg class="advent-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  var DEFAULT_STRINGS = {
    tagToday: 'Oggi',
    tagAvailable: 'Disponibile',
    tagOpened: 'Aperta',
    tagExpired: 'Scaduta'
  };

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Data di oggi come numero AAAAMMGG nel fuso orario del negozio
  function todayNumber(timeZone) {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (p) { map[p.type] = p.value; });
      return parseInt(map.year + map.month + map.day, 10);
    } catch (e) {
      var d = new Date();
      return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
    }
  }

  function format(str, values) {
    return String(str).replace(/%(\w+)%/g, function (m, k) { return values[k] != null ? values[k] : m; });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return legacyCopy(text);
  }

  // iOS meno recenti: serve una selezione esplicita
  function legacyCopy(text) {
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px;';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      ta.setSelectionRange(0, text.length);
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      ok ? resolve() : reject();
    });
  }

  class AdventCalendar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var stringsEl = this.querySelector('[data-advent-strings]');
      this.strings = Object.assign({}, DEFAULT_STRINGS, stringsEl ? JSON.parse(stringsEl.textContent) : {});
      this.sectionId = this.dataset.sectionId;
      this.root = this.dataset.root || '/';
      this.pastMode = this.dataset.pastMode;
      this.requireLogin = this.dataset.requireLogin === 'true';
      this.doors = Array.prototype.slice.call(this.querySelectorAll('.advent-door'));
      this.templates = this.querySelector('[data-advent-templates]');
      this.modal = this.querySelector('[data-advent-modal]');
      this.modalBody = this.querySelector('[data-advent-modal-body]');
      this.toastEl = this.querySelector('[data-advent-toast]');
      this.statusEl = this.querySelector('[data-advent-status]');
      this.opened = this.loadOpened();

      this.computeToday();
      this.applyStates();
      this.renderStatus();
      this.makeSnow();
      this.bindEvents();
      this.syncUnlocked();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
      clearInterval(this._countdownTimer);
      document.documentElement.classList.remove('advent-lock');
    }

    /* ---------- Date ---------- */

    computeToday() {
      var mode = this.dataset.previewMode;
      var first = this.unlockOf(this.doors[0]);
      var last = this.unlockOf(this.doors[this.doors.length - 1]);
      this.allOpen = mode === 'all_open';

      if (mode === 'simulate') {
        var day = parseInt(this.dataset.previewDay, 10) || 0;
        if (day <= 0) this.today = first - 1;
        else if (day > this.doors.length) this.today = last + 1;
        else this.today = this.unlockOf(this.doors[day - 1]);
      } else if (this.allOpen) {
        this.today = last;
      } else {
        this.today = todayNumber(this.dataset.timezone || 'Europe/Rome');
      }
      this.firstUnlock = first;
      this.lastUnlock = last;
    }

    unlockOf(door) {
      return door ? parseInt(door.dataset.unlock, 10) : 0;
    }

    stateOf(door) {
      if (this.allOpen) return 'past';
      var u = this.unlockOf(door);
      if (u > this.today) return 'future';
      if (u === this.today) return 'today';
      return 'past';
    }

    isExpired(door) {
      return !this.allOpen && this.pastMode === 'expired' && this.stateOf(door) === 'past';
    }

    /* ---------- Caselle ---------- */

    applyStates() {
      var self = this;
      this.doors.forEach(function (door) {
        var state = self.stateOf(door);
        var day = door.dataset.day;
        var isOpen = state !== 'future' && !!self.opened[day];
        door.classList.remove('is-future', 'is-today', 'is-past', 'is-open', 'is-expired');
        door.classList.add('is-' + state);
        if (isOpen) door.classList.add('is-open');
        if (self.isExpired(door)) door.classList.add('is-expired');

        var tag = door.querySelector('[data-advent-tag]');
        if (state === 'future') {
          tag.innerHTML = LOCK_ICON + '<span>' + door.dataset.dateShort + '</span>';
          door.setAttribute('aria-label', 'Casella ' + day + ', si apre il ' + door.dataset.dateLabel);
        } else {
          var text = state === 'today' ? self.strings.tagToday
            : self.isExpired(door) ? self.strings.tagExpired
            : isOpen ? self.strings.tagOpened : self.strings.tagAvailable;
          tag.textContent = text;
          door.setAttribute('aria-label', 'Casella ' + day + ', ' + text.toLowerCase() + ': apri');
        }
      });
    }

    renderStatus() {
      if (!this.statusEl || !this.doors.length) return;
      var s = this.strings;
      clearInterval(this._countdownTimer);

      if (this.today < this.firstUnlock) {
        var first = this.doors[0];
        this.statusEl.innerHTML =
          '<div class="advent-status"><span class="advent-status__dot"></span><span>' +
          format(s.before, { date: first.dataset.dateLabel }) + '</span></div>' +
          '<div class="advent-countdown" aria-hidden="true"></div>';
        this.startCountdown(this.statusEl.querySelector('.advent-countdown'), this.firstUnlock);
        return;
      }
      if (this.today > this.lastUnlock) {
        this.statusEl.innerHTML = s.ended
          ? '<div class="advent-status"><span class="advent-status__dot"></span><span></span></div>'
          : '';
        if (s.ended) this.statusEl.querySelector('.advent-status span:last-child').textContent = s.ended;
        return;
      }
      var today = this.doors.filter(function (d) { return parseInt(d.dataset.unlock, 10) === this.today; }, this)[0];
      if (!today) { this.statusEl.innerHTML = ''; return; }
      this.statusEl.innerHTML =
        '<div class="advent-status"><span class="advent-status__dot"></span><span>' +
        format(s.today, { date: today.dataset.dateLabel, n: today.dataset.day }) + '</span></div>';
    }

    startCountdown(el, unlockNum) {
      var s = this.strings;
      var y = Math.floor(unlockNum / 10000);
      var m = Math.floor((unlockNum % 10000) / 100) - 1;
      var d = unlockNum % 100;
      // Mezzanotte del giorno di apertura nel fuso del negozio, non del dispositivo
      var target = Date.UTC(y, m, d, 0, 0, 0);
      var tz = this.dataset.timezone || 'Europe/Rome';
      function nowInZone() {
        try {
          var parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: tz, hourCycle: 'h23',
            year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
          }).formatToParts(new Date());
          var p = {};
          parts.forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
          return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
        } catch (e) {
          var n = new Date();
          return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds());
        }
      }
      function tick() {
        var diff = Math.max(0, target - nowInZone());
        var days = Math.floor(diff / 864e5);
        var hours = Math.floor((diff % 864e5) / 36e5);
        var mins = Math.floor((diff % 36e5) / 6e4);
        el.innerHTML =
          '<div><b>' + days + '</b><small>' + s.days + '</small></div>' +
          '<div><b>' + String(hours).padStart(2, '0') + '</b><small>' + s.hours + '</small></div>' +
          '<div><b>' + String(mins).padStart(2, '0') + '</b><small>' + s.minutes + '</small></div>';
      }
      tick();
      this._countdownTimer = setInterval(tick, 30000);
    }

    /* ---------- Memoria caselle aperte (solo su questo browser) ---------- */

    loadOpened() {
      try {
        return JSON.parse(window.localStorage.getItem(this.dataset.storageKey) || '{}') || {};
      } catch (e) {
        return {};
      }
    }

    saveOpened() {
      try { window.localStorage.setItem(this.dataset.storageKey, JSON.stringify(this.opened)); } catch (e) {}
    }

    /* ---------- Contenuti ---------- */

    templateFor(day) {
      return this.templates.querySelector('template[data-advent-content="' + day + '"]');
    }

    // La pagina può arrivare dalla cache: chiede al server i contenuti dei giorni appena sbloccati
    fetchSection() {
      if (this._fetching) return this._fetching;
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(this.sectionId) + '&advent=' + Date.now();
      var self = this;
      this._fetching = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('template[data-advent-content]').forEach(function (tpl) {
            if (!self.templateFor(tpl.dataset.adventContent)) self.templates.appendChild(document.importNode(tpl, true));
          });
          self.doors.forEach(function (door) {
            var fresh = doc.querySelector('.advent-door[data-day="' + door.dataset.day + '"] [data-advent-inside]');
            if (fresh && self.templateFor(door.dataset.day)) {
              door.querySelector('[data-advent-inside]').innerHTML = fresh.innerHTML;
            }
          });
        })
        .catch(function () {})
        .then(function () { self._fetching = null; });
      return this._fetching;
    }

    syncUnlocked() {
      if (this.requireLogin) return;
      var self = this;
      var missing = this.doors.some(function (door) {
        return self.stateOf(door) !== 'future' && !self.templateFor(door.dataset.day);
      });
      if (missing) this.fetchSection();
    }

    /* ---------- Eventi ---------- */

    bindEvents() {
      var self = this;

      this.querySelector('.advent-calendar__grid').addEventListener('click', function (e) {
        var door = e.target.closest('.advent-door');
        if (door) self.onDoorClick(door);
      });

      this.modal.addEventListener('click', function (e) {
        if (e.target === self.modal || e.target.closest('[data-advent-close]')) { self.closeModal(); return; }
        var copyBtn = e.target.closest('[data-advent-copy]');
        if (copyBtn) { self.onCopy(copyBtn); return; }
        var addBtn = e.target.closest('[data-advent-add]');
        if (addBtn) self.onAdd(addBtn);
      });

      this.modal.addEventListener('cancel', function (e) { e.preventDefault(); self.closeModal(); });
      this.modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.modal.classList.contains('is-fallback')) self.closeModal();
      });

      this._onBlockSelect = function (e) {
        if (!e.detail || !self.contains(e.target)) return;
        var door = self.querySelector('.advent-door[data-block-id="' + e.detail.blockId + '"]');
        if (!door) return;
        door.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
        var tpl = self.templateFor(door.dataset.day);
        if (tpl) self.openModal(door, tpl);
      };
      this._onBlockDeselect = function (e) {
        if (self.contains(e.target)) self.closeModal();
      };
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
    }

    onDoorClick(door) {
      var self = this;
      var day = door.dataset.day;

      if (this.stateOf(door) === 'future') {
        this.shake(door);
        this.toast(format(this.strings.locked, { n: day, date: door.dataset.dateLabel }));
        return;
      }

      if (this.requireLogin) {
        this.openModal(door, this.templates.querySelector('template[data-advent-login]'));
        return;
      }

      var getTemplate = this.templateFor(day)
        ? Promise.resolve(this.templateFor(day))
        : this.fetchSection().then(function () { return self.templateFor(day); });

      getTemplate.then(function (tpl) {
        if (!tpl) {
          // Il server non lo considera ancora sbloccato (es. orologio del dispositivo avanti)
          self.shake(door);
          self.toast(format(self.strings.locked, { n: day, date: door.dataset.dateLabel }));
          return;
        }
        if (door.classList.contains('is-open')) { self.openModal(door, tpl); return; }
        self.opened[day] = true;
        self.saveOpened();
        door.classList.add('is-open');
        self.applyStates();
        setTimeout(function () { self.openModal(door, tpl); }, reducedMotion() ? 0 : 600);
      });
    }

    shake(door) {
      door.classList.remove('is-shaking');
      void door.offsetWidth;
      door.classList.add('is-shaking');
    }

    /* ---------- Popup ---------- */

    openModal(door, tpl) {
      var m = this.modal;
      this.lastDoor = door;
      m.querySelector('[data-advent-modal-day]').textContent = door.dataset.day;
      m.querySelector('[data-advent-modal-month]').textContent = door.dataset.dateLabel.replace(/^\d+\s*/, '');
      m.querySelector('[data-advent-modal-kind]').textContent = tpl.dataset.typeName || '';
      this.modalBody.innerHTML = '';
      this.modalBody.appendChild(tpl.content.cloneNode(true));
      this.modalBody.scrollTop = 0;

      var expired = this.isExpired(door) && tpl.hasAttribute('data-advent-content');
      m.classList.toggle('is-expired', expired);
      var note = this.modalBody.querySelector('[data-advent-expired-note]');
      if (note) note.textContent = format(this.strings.expired, { date: door.dataset.dateLabel });

      if (!m.open) {
        if (typeof m.showModal === 'function') {
          m.showModal();
        } else {
          m.classList.add('is-fallback');
          m.setAttribute('open', '');
        }
      }
      document.documentElement.classList.add('advent-lock');
      var close = m.querySelector('[data-advent-close]');
      if (close) close.focus({ preventScroll: true });

      this.updateThreshold();
    }

    closeModal() {
      var m = this.modal;
      if (!m.open && !m.hasAttribute('open')) return;
      if (typeof m.close === 'function' && !m.classList.contains('is-fallback')) m.close();
      else m.removeAttribute('open');
      document.documentElement.classList.remove('advent-lock');
      if (this.lastDoor) this.lastDoor.focus({ preventScroll: true });
    }

    updateThreshold() {
      var box = this.modalBody.querySelector('[data-advent-threshold]');
      if (!box) return;
      var min = parseInt(box.dataset.adventThreshold, 10);
      var s = this.strings;
      fetch(this.root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var total = cart.total_price || 0;
          var pct = Math.min(100, Math.round((total / min) * 100));
          box.querySelector('[data-advent-threshold-bar]').style.width = pct + '%';
          var text = box.querySelector('[data-advent-threshold-text]');
          text.innerHTML = total >= min
            ? s.thresholdReached
            : format(s.thresholdMissing, { amount: formatMoney(min - total, cart.currency) });
        })
        .catch(function () {});
    }

    onCopy(btn) {
      var s = this.strings;
      copyText(btn.dataset.adventCopy).then(function () {
        btn.textContent = s.copied;
        setTimeout(function () { btn.textContent = s.copy; }, 1800);
      }, function () {
        // Ultima spiaggia: il codice resta selezionabile a mano
        var value = btn.parentNode.querySelector('.advent-code__value');
        if (value && window.getSelection) {
          var range = document.createRange();
          range.selectNodeContents(value);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
      });
    }

    onAdd(btn) {
      var self = this;
      var items;
      try { items = JSON.parse(btn.dataset.adventAdd); } catch (e) { return; }
      var code = btn.dataset.adventCode;
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = this.strings.adding;

      fetch(this.root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || '');
            return data;
          });
        })
        .then(function () {
          var cartUrl = self.root + 'cart';
          window.location.href = code
            ? self.root + 'discount/' + encodeURIComponent(code) + '?redirect=' + cartUrl
            : cartUrl;
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.innerHTML = label;
          self.toast((err && err.message) || self.strings.addError);
        });
    }

    toast(msg) {
      var el = this.toastEl;
      // Con il popup aperto il dialog sta sopra tutto: l'avviso va spostato dentro il dialog per restare visibile
      var host = this.modal && (this.modal.open || this.modal.hasAttribute('open')) ? this.modal : this;
      if (el.parentNode !== host) host.appendChild(el);
      el.textContent = msg;
      el.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
    }

    /* ---------- Neve ---------- */

    makeSnow() {
      var box = this.querySelector('.advent-calendar__snow');
      if (!box || reducedMotion() || box.childElementCount) return;
      var count = window.innerWidth < 768 ? 12 : 24;
      // La neve cade per tutta l'altezza della sezione (su mobile la griglia è molto alta)
      box.style.setProperty('--advent-fall', (this.offsetHeight + 20) + 'px');
      for (var i = 0; i < count; i++) {
        var f = document.createElement('i');
        var size = 3 + Math.random() * 5;
        f.style.left = (Math.random() * 100) + '%';
        f.style.width = f.style.height = size + 'px';
        f.style.animationDuration = Math.max(12, (12 + Math.random() * 14) * (this.offsetHeight / 900)) + 's';
        f.style.animationDelay = (-Math.random() * 20) + 's';
        box.appendChild(f);
      }
    }
  }

  window.customElements.define('advent-calendar', AdventCalendar);
})();
